import { DateTime } from 'luxon';
import { DEFAULT_TIME_ZONE } from '@galapagos/shared';

/**
 * The year printed in the footer's copyright notice. It is the company's
 * notice, not a member-local date, so it is decided in the product's one
 * default zone rather than whichever zone the visitor's browser runs in;
 * otherwise two visitors could see different years on New Year's Eve.
 */
export function copyrightYear(now: DateTime = DateTime.now()): number {
  return now.setZone(DEFAULT_TIME_ZONE).year;
}
